import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';

function Navigation({ handleToggle }) {
    const [menuItems, setMenuItems] = useState([]);

    const location = useLocation();
    const current = location.pathname;

    useEffect(() => {
        const items = [
            {
                key: 1,
                link: '/',
                title: 'Home',
            },
            {
                key: 2,
                link: '/about',
                title: 'About Us',
            },
            { key: 3, link: '/turnaround', title: 'Turnaround Times' },
            { key: 4, link: '/contact', title: 'Contact Us' },
            {
                key: 5,
                link: '',
                title: 'Services & Pricing',
                submenu: [
                    {
                        key: 11,
                        link: '/tanning-services',
                        title: 'Tanning Services',
                    },
                    {
                        key: 12,
                        link: '/prices',
                        title: 'Price Lists',
                    },
                    {
                        key: 13,
                        link: '/resources',
                        title: 'Resources',
                    },
                    {
                        key: 14,
                        link: '/legal-compliance',
                        title: 'Legal Compliance',
                    },
                    {
                        key: 15,
                        link: '/forms',
                        title: 'Forms',
                    },
                ],
            },
            {
                key: 6,
                title: 'Tools',
                submenu: [
                    {
                        key: 17,
                        link: '/check-order',
                        title: 'Order Status',
                    },
                    {
                        key: 18,
                        link: '/payment',
                        title: 'Pay an Order',
                    },
                ],
            },
        ];

        setMenuItems(items);
    }, []);

    return (
        <>
            {menuItems.map(({ key, link, title, submenu }) => {
                if (submenu)
                    return (
                        <div className="add-arrow with-submenu" key={key}>
                            {title}
                            <div className="submenu">
                                {submenu.map(submenuItem => {
                                    return (
                                        <Link
                                            key={submenuItem.key}
                                            to={submenuItem.link}
                                            onClick={handleToggle}
                                            className={current === submenuItem.link ? 'active' : ''}
                                        >
                                            <div>{submenuItem.title}</div>
                                        </Link>
                                    );
                                })}
                            </div>
                        </div>
                    );
                return (
                    <Link
                        key={key}
                        to={link}
                        onClick={handleToggle}
                        className={current === link ? 'active' : ''}
                    >
                        <div>{title}</div>
                    </Link>
                );
            })}
        </>
    );
}

Navigation.propTypes = {
    handleToggle: PropTypes.func.isRequired,
};

export default Navigation;
